<div class="h-100 flex-row items-center justify-center">
    <mat-card class="p-0 mat-elevation-z6">
        <div class="mt-3 flex-col items-center">
            <mat-icon class="mat-icon-xlg">error</mat-icon>
            <h1 class="error">404</h1>
        </div>
        <mat-card-content class="flex-col items-stretch items-center">
            <mat-card class="mx-5 py-6 mat-elevation-z8">
                <mat-card-content>
                    <span >We ran into an issue fulfilling your request. Please try again later.</span> 
                </mat-card-content>
            </mat-card>
            <div class="home-button text-center">
                <button mat-raised-button color="primary" class="mat-elevation-z8" type="button" (click)="goHome()">
                    <span class="w-100 justify-center"><mat-icon>home</mat-icon></span>
                </button>
            </div>
        </mat-card-content>
    </mat-card>        
</div>